import React from "react";
const getFillColor = (color: string) => {
  return color === "currentColor" ? `` : `var(--color-${color})`;
};
const SvgFacebookIcon = ({ title, theme = null, titleId = "", ...props }) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      d="M15.232.03c-2.046.11-3.921.555-5.727 1.36a16.016 16.016 0 0 0-8.93 10.395 15.768 15.768 0 0 0-.555 4.468 15.93 15.93 0 0 0 1.94 7.406 16.05 16.05 0 0 0 6.846 6.629 15.892 15.892 0 0 0 3.283 1.227l.042.009V20.898l-1.646-.003-1.648-.004v-4.883l1.644-.005L12.127 16l.008-1.425c.008-1.382.014-1.582.066-2.137.261-2.813 1.382-4.691 3.386-5.674.901-.442 1.97-.702 3.315-.806.35-.028 1.265-.037 1.628-.017.877.05 1.848.163 2.503.293.164.034.32.066.345.074l.046.012.005 2.225.003 2.224-.095-.01c-.45-.046-2.044-.064-2.431-.029-1.007.092-1.668.343-2.134.81-.352.351-.58.813-.705 1.424-.098.478-.117.811-.117 2.041V16h2.61c1.436 0 2.61.006 2.61.012 0 .008-.199 1.104-.444 2.437-.245 1.333-.446 2.43-.446 2.437 0 .006-.973.012-2.165.012H17.95v5.49c0 4.38.005 5.49.02 5.49a15.95 15.95 0 0 0 7.842-3.238 16.55 16.55 0 0 0 2.45-2.361 16.52 16.52 0 0 0 1.733-2.517c.302-.54.721-1.437.947-2.031a16.088 16.088 0 0 0 .734-8.93 16.012 16.012 0 0 0-5.327-8.994A15.951 15.951 0 0 0 18.65.23c-.48-.08-1.02-.14-1.597-.184a28.613 28.613 0 0 0-1.82-.015Z"
      fill="currentColor"
    />
  </svg>
);
export interface Props {
  color?: string;
  width?: string;
  height?: string;
  title: string;
  titleId?: string;
  theme?: any;
  fill?: string;
}
const SvgFacebookStyle = ({
  color = "currentColor",
  title,
  fill,
  ...props
}: Props) => (
  <SvgFacebookIcon
    color={getFillColor(color)}
    className={color === "currentColor" ? "icon-current-color" : ""}
    {...(color !== "currentColor"
      ? { style: { color: getFillColor(color), fill: getFillColor(color) } }
      : null)}
    fill={fill ?? getFillColor(color)}
    title={title}
    {...props}
  />
);
export const FacebookIcon: any = SvgFacebookStyle;
export default FacebookIcon;
